module.exports = __webpack_public_path__ + "img/1f9f8.ddae3df.svg";